import Vue from "vue";

const getIntegrationIdByName = (integrationName) => {
  const integrations = {
    activeCampaign: "1",
    zendesk: "2",
    rdStation: "3",
    lGaming: "4",
  };

  return integrations[integrationName];
};

const addUserIntegration = (userId, userIntegrationId, integrationName) => {
  Vue.prototype.$axios.post(
    "/player/user/addIntegration",
    Vue.prototype.$formdata({
      user_id: userId,
      user_integration_id: userIntegrationId,
      integration_id: getIntegrationIdByName(integrationName),
    })
  );
  // .then((r) => { console.log(r); }).catch((e) => { console.log(e); });
};

export { getIntegrationIdByName, addUserIntegration };